<div
  class="avatar-frame"
  [class.small]="size === 'small'"
  [class.medium]="size === 'medium'"
  [class.large]="size === 'large'">
  @if (avatarUrl) {
    <img
      [src]="avatarUrl"
      [alt]="username ? 'Avatar for ' + username : 'User avatar'"
      loading="lazy"
    />
  } @else {
    <div
      class="avatar-initial"
      role="img"
      [attr.aria-label]="username ? 'Avatar for ' + username : 'User avatar'">
      {{ (username || '?').trim().charAt(0).toUpperCase() }}
    </div>
  }

</div>
